import { render, staticRenderFns } from "./PricesProductCard.vue?vue&type=template&id=308c6e18&"
import script from "./PricesProductCard.vue?vue&type=script&lang=js&"
export * from "./PricesProductCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports